import { __assign } from "tslib";
import has from 'lodash/has';
import mergeWith from 'lodash/mergeWith';
import pickBy from 'lodash/pickBy';
var cssClassMerger = function (defaultStyleClassName, themeClassName) {
    return defaultStyleClassName + " " + themeClassName;
};
export var mergeStyles = function (_a) {
    var styles = _a.styles, theme = _a.theme;
    if (!theme) {
        console.warn('mergeStyles invoked without theme!'); // eslint-disable-line no-console
        return styles;
    }
    var themeStyles = pickBy(theme);
    var themeStylesToMerge = pickBy(themeStyles, function (_, key) { return has(styles, key); });
    return mergeWith(__assign({}, styles), themeStylesToMerge, cssClassMerger);
};
//# sourceMappingURL=mergeStyles.js.map